import axios from 'axios'
import qs from 'qs'
import Router from '../router/index'
import { alertModelMsg } from "@/utils/common.js";
import { baseUrl } from "./global";

export function request (config) {
  // 1.创建axios的实例
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 5000 // 请求超时
  })
  // qs参数编码
  instance.defaults.paramsSerializer = function (params) {
    return qs.stringify(params, { arrayFormat: 'brackets' })
  }
  // 2.axios的拦截器
  // 2.1.请求拦截的作用
  instance.interceptors.request.use(config => {
    config.headers = {
      'Content-Type': 'application/json'
    }
    // const token = localStorage.getItem('token')
    // if (token) {
    //   // token注入
    //   config.headers.LHTOKEN = window.sessionStorage.getItem('token')
    // }
    return config
  }, error => {
    console.log("请求拦截错误："+error)
  })

  // 2.2.响应拦截
  instance.interceptors.response.use(
    res => {
      if (res.status === 200) {
        if (res.data.code !== 1) {
          if (res.data.status === '401') {
            // window.sessionStorage.removeItem('token')
            Router.replace({
              path: '/login'
            })
          }
        } 
        return res.data
      } else {
        alertModelMsg('服务器错误 请稍后再试')
      }
    },
    error => {
      console.log(error.response) // for debug
      if (error.response) {
        if (error.response.status === 401) {
          // to re-login
          // window.sessionStorage.removeItem('token')
          Router.replace({
            path: '/login'
          })
        } else {
          alertModelMsg(error.response.status + ':' + error.response.statusText)
        }
      } else {
        alertModelMsg('服务器错误 请稍后再试')
      }
      return Promise.reject(error)
    })

  // 3.发送真正的网络请求
  return instance(config)
}
